<template>
  <div :style="fullWindow4to3RatioDimensionStyle" v-if="!isLoading" class="relative">
    <OaiLiveImagePlayer
      v-if="shouldShowImage"
      :cameraId="route.params.camera_id as string"
      :showControls="false"
      :reloadIntervalInMs="60 * 60 * 1000"
    />
    <OaiLiveVideoPlayer v-else :cameraId="route.params.camera_id as string" />
    <LogoWatermark class="absolute top-2 right-2" />
  </div>
  <div v-else class="flex items-center justify-center h-screen">
    <LoadingSpinner />
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import OaiLiveImagePlayer from "shared/components/camera/OaiLiveImagePlayer.vue";
import OaiLiveVideoPlayer from "shared/components/camera/OaiLiveVideoPlayer.vue";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import LogoWatermark from "shared/components/other/LogoWatermark.vue";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import { useFullWindow4to3RatioDimensionStyle } from "shared/composables/screen";
import PublicTokenRepository from "shared/repositories/PublicTokenRepository";
import logger from "shared/services/logger";

const isLoading = ref(true);
const shouldShowImage = ref(false);

const route = useRoute();

const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();
const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();

onMounted(() => {
  PublicTokenRepository.loadPublicTokenByToken(currentCustomerName, currentSiteId)
    .then((publicToken) => {
      shouldShowImage.value = publicToken.claims.includes("camera_live_image");
    })
    .catch((error) => {
      if (!PublicTokenRepository.isPublicTokenAuthError(error)) {
        logger.error(error);
      }
    })
    .finally(() => {
      isLoading.value = false;
    });
});
</script>
